import useApplyLocale from "components/hooks/useApplyLocale";
import { memo } from "react";
import { useSelector } from "react-redux";
import { MasterSelector } from "redux/selector";
import { stringFormat } from "utils/common-util";
import DangerousMessage from "../DangerousMessage";

const ErrorMessageConst = ({ code, params, displayCode, dangerous, htmlTag, ...props }) => {
  const { textTh, textEn } = useSelector(MasterSelector.errorConst)[code] ?? {};
  let messageLocale = useApplyLocale({ th: textTh, en: textEn, fallback: "th" });
  messageLocale = stringFormat(messageLocale, params);
  messageLocale = displayCode ? `${messageLocale} (Code: ${code}):`.trim() : messageLocale;

  if (dangerous) {
    messageLocale = messageLocale?.replace(/\n/g, "<br/>");
    if (htmlTag)
      return <DangerousMessage className="custom-message-1" html={messageLocale} htmlTag={htmlTag} {...props} />;
    else return <DangerousMessage.Div className="custom-message-1" html={messageLocale} {...props} />;
  }

  return <span {...props}>{messageLocale}</span>;
};

export default memo(ErrorMessageConst);

ErrorMessageConst.defaultProps = {
  displayCode: false,
};
